import styles from "./HotelHero.module.css";
import { HiOutlineLocationMarker } from "react-icons/hi";



export default function HotelHero({ hotel }) {
  if (!hotel) return null;
const googleMapsUrl =
  hotel.latitude && hotel.longitude
    ? `https://www.google.com/maps/search/?api=1&query=${hotel.latitude},${hotel.longitude}`
    : hotel.google_map_url || null;
  return (
    <section
      className={styles.hero}
      aria-labelledby="hotel-title"
    >
      <div className={styles.imageWrapper}>
        <img
          src={hotel.featured_image || "/hotel.jpg"}
          alt={`${hotel.name} - Luxury Hotel in ${hotel.city}`}
          className={styles.heroImage}
          loading="eager"
          fetchPriority="high"
        />
      </div>

      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <span className={styles.tag}>
          Luxury Hotel & Convention Venue
        </span>

        <h1
          id="hotel-title"
          className={styles.hotelName}
        >
          {hotel.name}
        </h1>
<div className={styles.locationRow}>
  <address className={styles.location}>
    {hotel.city}, {hotel.state}, {hotel.country}
  </address>

  {googleMapsUrl && (
  <a
  href={googleMapsUrl}
  target="_blank"
  rel="noopener noreferrer"
  className={styles.mapLink}
>
<HiOutlineLocationMarker className={styles.mapIcon} />  View on Maps
</a>
  )}
</div>
        <div className={styles.rating}>
  <span className={styles.stars}>
    {"★".repeat(hotel.star_rating || 0)}
  </span>

  {hotel.star_rating ? (
    <span className={styles.ratingText}>
      Luxury {hotel.star_rating}-Star Property
    </span>
  ) : null}
</div>
      </div>
    </section>
  );
}